import { ApplicationConstants } from '../../../../shared/applicationConstants';
import { SharedService } from '../../../../shared/services/sharedService';
import { AuthService } from '../../../../login/services/authService.js';

export class ClonarMapaService {

    static migrateMap(businessId, nom){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.migrateMap, { token: token, uid: uid, businessId: businessId, nom: nom, privacitat: 'P'}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/gallery/components/clonar-modal/services/clonarMapaService.js